import {collections} from './collections';

class UserService {
    getById = userId => collections().users().doc(userId).get();

    create = (userId, data) => collections().users().doc(userId).set(data);

    updateUserData = (userId, updatedList) =>
        collections().users().doc(userId).update(updatedList);
}

export default new UserService();
